import get from 'lodash.get';
import { defaultNumberFormatterOptions } from './defaults.js';
import { NullLogger } from '@fds/wm-typescript-logger';

class NumberFormatter {
  constructor(configurationOrOptions) {
    var _a, _b, _c, _d, _e, _f;
    if (NumberFormatter.isOptions(configurationOrOptions)) {
      this.emptyValue = (_a = configurationOrOptions.emptyValue) != null ? _a : defaultNumberFormatterOptions.emptyValue;
      this.assetClassFormats = {
        ...defaultNumberFormatterOptions.assetClassFormats,
        ...configurationOrOptions.assetClassFormats
      };
      this.typeFormats = {
        ...defaultNumberFormatterOptions.typeFormats,
        ...configurationOrOptions.typeFormats
      };
      this.logger = new NullLogger();
    } else {
      this.logger = (_b = configurationOrOptions == null ? void 0 : configurationOrOptions.logger) != null ? _b : new NullLogger();
      this.emptyValue = (_d = (_c = configurationOrOptions == null ? void 0 : configurationOrOptions.options) == null ? void 0 : _c.emptyValue) != null ? _d : defaultNumberFormatterOptions.emptyValue;
      this.assetClassFormats = {
        ...defaultNumberFormatterOptions.assetClassFormats,
        ...(_e = configurationOrOptions == null ? void 0 : configurationOrOptions.options) == null ? void 0 : _e.assetClassFormats
      };
      this.typeFormats = {
        ...defaultNumberFormatterOptions.typeFormats,
        ...(_f = configurationOrOptions == null ? void 0 : configurationOrOptions.options) == null ? void 0 : _f.typeFormats
      };
    }
    this.logger.debug(`${this.constructor.name} initialized with:`, {
      emptyValue: this.emptyValue,
      assetClassFormats: this.assetClassFormats,
      typeFormats: this.typeFormats
    });
  }
  static isOptions(configurationOrOptions) {
    return (configurationOrOptions == null ? void 0 : configurationOrOptions.emptyValue) !== void 0 || (configurationOrOptions == null ? void 0 : configurationOrOptions.assetClassFormats) !== void 0 || (configurationOrOptions == null ? void 0 : configurationOrOptions.typeFormats) !== void 0;
  }
  format(value, options) {
    var _a, _b;
    if (value === null || Number.isNaN(value)) {
      return this.emptyValue;
    }
    if ((options == null ? void 0 : options.locale) === void 0) {
      return value.toString();
    }
    const formatterOptions = this.getOptions((_a = options.assetClass) != null ? _a : null, (_b = options.type) != null ? _b : null);
    try {
      return value.toLocaleString(options.locale, formatterOptions);
    } catch (e) {
      this.logger.error("IntlNumberFormatter: ", e);
      return value.toString();
    }
  }
  getOptions(assetClass, type) {
    var _a, _b;
    const assetClassOptions = get(this.assetClassFormats, assetClass != null ? assetClass : "default", (_a = this.assetClassFormats.default) != null ? _a : {});
    const typeOptions = get(this.typeFormats, type != null ? type : "", (_b = this.typeFormats.default) != null ? _b : {});
    return { ...assetClassOptions, ...typeOptions };
  }
}

export { NumberFormatter };
